

















































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import {
  ArenaSignSignerRoleModel,
  ArenaSignSignerRoleConfigurationModel,
  ArenaSignSignerRoleCreateUpdateModel,
  Configuration
} from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import ArenaSignUpdateSignerRole from '@/components/configuration/arenaSign/ArenaSignUpdateSignerRole.vue';

export default Vue.extend({
  name: 'DocusignEditSignerRole',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  data() {
    return {
      isLoading: false,
      signerRoleConfiguration: {} as ArenaSignSignerRoleConfigurationModel,
      signerRole: {} as ArenaSignSignerRoleCreateUpdateModel,
      submitIsLoading: false,
      serverValidationMessage: '',
      hasError: false,
      errorMessage: '',
      authenticationTypes: [{description: 'Standard', key: 0}]
    };
  },
  methods: {
    getData(this: any) {
      this.getSignerRoleAsync(this.signerRoleId);
    },
    async onSubmit(this: any, signerRole: ArenaSignSignerRoleCreateUpdateModel) {
      this.resetFormValidation();
      try {
        this.submitIsLoading = true;
        const result = await DocuSignConfigurationService.updateSignerRoleAsync(
          this.documentTypeId,
          this.signerRoleId,
          this.signerRole
        );

        if (result.hasNotification && !result.showToast) {
          this.serverValidationMessage = result.notification;
          this.addFormValidationError(result.notification);
          this.submitIsLoading = false;
          return;
        }

        SnotifyConfiguration.showSuccess('Signer updated successfully.');
        this.setApplicationDirty(false);
        this.navigateToSignerRolebManagement();
      } catch (error) {
        this.serverValidationMessage = 'Error updating signer role';
      } finally {
        this.submitIsLoading = false;
      }
    },
    async getSignerRoleAsync(this: any, id: number) {
      this.isLoading = true;
      try {
        this.signerRoleConfiguration = await DocuSignConfigurationService.getSignerRoleConfigurationAsync({
          documentTypeId: this.documentTypeId,
          signerRoleId: this.signerRoleId
        });
        this.signerRole = this.signerRoleConfiguration.signerRole;
      } catch (error) {
        this.signerRole = {} as ArenaSignSignerRoleModel;
        this.serverValidationMessage = 'Error getting additional document sign tab';
      } finally {
        this.isLoading = false;
      }
    },
    navigateToSignerRolebManagement(this: any, id: number) {
      const documentTypeId = id ?? this.documentTypeId;
      this.$router.push({ name: Configuration.DocuSign.SignerRole.Management.name, params: { documentTypeId } });
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    signerRoleId(): number {
      return Number(this.$route.params.id);
    },
    pageTitle(): string {
      return `Edit Signer Role (${this.signerRole.description})`;
    }
  },
  mounted(this: any) {
    this.getData();
  },
  components: {
    MStoreFormSelect,
    LoadingSpinner,
    ArenaSignUpdateSignerRole
  }
});
